import Immutable from 'immutable';

// constants
import { TRANSACTIONS_FETCH } from '../constants/transactionsTypes';

// lib
import httpReducer from '../lib/httpReducer';
import { callbackHandler, merge } from '../lib/mapReducerHelpers';

export default function(state = Immutable.Map(), action) {
  switch (action.type) {
    case TRANSACTIONS_FETCH: return httpReducer(state, action, callbackHandler(merge, 'transaction'));
    default: return state;
  }
}



// WEBPACK FOOTER //
// ./app/reducers/transactions.js